import { render, staticRenderFns } from "./CustomScoringSettings.vue?vue&type=template&id=527741b0"
import script from "./CustomScoringSettings.vue?vue&type=script&lang=js"
export * from "./CustomScoringSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports